import { Caption } from '@depop/web-thrift-ui/Typography';
import { ShipIcon } from '@depop/web-ui-kit/Icons/ShipIcon';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { useShowPdpFreeShippingMessaging } from '@/components/USFreeShippingBanner/useShowPdpFreeShippingMessaging';
import { useProductBySlugExtendedPDP } from '@/modules/product/hooks/useProductBySlugExtendedPDP';

type Props = {
  className?: string;
};
function FreeShipping({ className }: Props) {
  const t = useTranslations('common');
  const { data: productExtended } = useProductBySlugExtendedPDP();
  const campaignMessagingShown = useShowPdpFreeShippingMessaging();

  if (!productExtended?.has_free_shipping || campaignMessagingShown) {
    return null;
  }

  return (
    <div className={clsx(className, styles.container)} role="note">
      <ShipIcon size={20} />
      <Caption variant="lg-regular" bold className={styles.shippingMessage}>
        {t('FreeShipping')}
      </Caption>
    </div>
  );
}

export { FreeShipping };
